/**
 * ReadOnlyInput Component
 *
 * Displays a form input that is disabled and shows as read-only.
 * Used for fields like name and email that cannot be edited.
 */

import React from "react";
import { FormField } from "./FormField";

export interface ReadOnlyInputProps {
  /** Field label text */
  label: string;
  /** Input name and id */
  name: string;
  /** Current value */
  value: string;
  /** Input type (default: "text") */
  type?: string;
  /** Help text shown below the field */
  helpText?: string;
  /** Additional data attributes to suppress password managers */
  suppressPasswordManagers?: boolean;
}

/**
 * ReadOnlyInput - Disabled input field with consistent styling
 */
export const ReadOnlyInput: React.FC<ReadOnlyInputProps> = ({
  label,
  name,
  value,
  type = "text",
  helpText,
  suppressPasswordManagers = false,
}) => {
  return (
    <FormField label={label} htmlFor={name} helpText={helpText}>
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        disabled
        className="form-input-disabled"
        {...(suppressPasswordManagers
          ? {
              "data-lpignore": "true",
              "data-1p-ignore": "true",
              "data-bwignore": "true",
              "data-form-type": "other",
              autoComplete: "off",
            }
          : {})}
      />
    </FormField>
  );
};
